import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";

export interface UpdateDeliveryZoneBody {
  zoneId: string;
  isActive?: boolean;
  isExpedition?: boolean;
  isHiddenFromResellers?: boolean;
  /** Replaces the whole list. Omit to leave it alone; [] clears it. */
  allowedResellerIds?: string[];
}

export const requestUpdateDeliveryZone = async ({
  zoneId,
  ...body
}: UpdateDeliveryZoneBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesDeliveryFees.DeliveryZone, zoneId),
    body
  );
};
